<template lang='pug'>
    Log(:title="title")
</template>

<script>
import Log from "../components/Log.vue"
export default {
    name: "LogActivity",
    components: {
        Log
    },
    data: () => ({
        title: "Log Activity"
    })
}
</script>
